import React from 'react';
import { useSelector } from 'react-redux';
import AboutUsSection from '../about/AboutUS';
import ProjectInfo from '../projectinfo/ProjectInfo';
import TeamSlider from '../about/AboutCard';

const ViewProject = () => {
  const { language } = useSelector((state) => state.language);

  const translations = {
    gb: {
      heading: "View Project",
      buttonText: "Learn More",
    },
    sa: {
      heading: "عرض المشروع",
      buttonText: "اعرف المزيد",
    },
    fr: {
      heading: "Voir le projet",
      buttonText: "En savoir plus",
    },
    de: {
      heading: "Projekt ansehen",
      buttonText: "Mehr erfahren",
    }
  };

  const t = translations[language] || translations.gb;

  console.log('Current language:', language);
  console.log('Current translation:', t);

  return (
    <>
      <AboutUsSection
        heading={t.heading}
        buttonText={t.buttonText}
        language={language}
      />
      <ProjectInfo/>
      <TeamSlider/>
    </>
  );
};

export default ViewProject;
